import axios from 'axios';
import { get } from 'lodash';
import { generatePath } from 'react-router-dom';

import { API_URL, CHANGE_DISTANCE_DETAILS_END_POINT, CHANGE_DISTANCE_REQUEST_END_POINT } from 'src/constants';

import { action, request } from 'utils';

import { CHANGE_DISTANCE_DETAILS_UNKNOWN, CREATE_CHANGE_DISTANCE_REQUEST, LOAD_CHANGE_DISTANCE_DETAILS } from '../constants';

import { ChangeDistanceDetails, ChangeDistanceDetailsResult, ChangeDistanceRequest, ChangeDistanceRequestResult } from '../types';

class ChangeDistanceService {
  @request({ action: CREATE_CHANGE_DISTANCE_REQUEST, authOnly: true })
  private async createChangeDistanceRequest(racerId: number, distanceId: number): Promise<any> {
    const url = generatePath(API_URL + CHANGE_DISTANCE_REQUEST_END_POINT, { racerId });
    return axios.post(url, { distance_id: distanceId });
  }

  @action({ action: CREATE_CHANGE_DISTANCE_REQUEST })
  async createChangeDistanceRequestToken(racerId: number, distanceId: number): Promise<ChangeDistanceRequestResult> {
    const [status, response] = await this.createChangeDistanceRequest(racerId, distanceId);

    if (!status) {
      return {
        ok: false,
        message: get(response, 'data.errors.distance_id[0]') || null,
        code: get(response, 'data.error_codes.distance_id[0]') || null,
      };
    }

    const changeDistanceRequest: ChangeDistanceRequest | null = get(response, 'data.data') || null;

    if (!changeDistanceRequest?.token) {
      return { ok: false, message: null, code: null };
    }

    return { ok: true, request: changeDistanceRequest };
  }

  @request({ action: LOAD_CHANGE_DISTANCE_DETAILS })
  private async loadDetailsRequest(token: string): Promise<any> {
    const url = generatePath(API_URL + CHANGE_DISTANCE_DETAILS_END_POINT, { token });
    return axios.get(url);
  }

  @action({ action: LOAD_CHANGE_DISTANCE_DETAILS })
  async loadDetails(token: string): Promise<ChangeDistanceDetailsResult> {
    const [status, response] = await this.loadDetailsRequest(token);

    if (!status) {
      return { ok: false, code: get(response, 'data.error_code') || CHANGE_DISTANCE_DETAILS_UNKNOWN };
    }

    const details: ChangeDistanceDetails | null = get(response, 'data.data') || null;

    if (!details?.token) {
      return { ok: false, code: CHANGE_DISTANCE_DETAILS_UNKNOWN };
    }

    return { ok: true, details };
  }
}

const changeDistanceService = new ChangeDistanceService();

export { changeDistanceService };
